'use client';

import { c as _c } from "react/compiler-runtime";
import { Suspense } from 'react';
import { LoadingPageTemplate } from '@/components/client';
import { InterestPolicyFilter } from '@/components/client/Form/InterestPolicyFilter';
import { ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useGetInterestedPolicyFilterDataQuery } from '@/hooks/useGetInterestedPolicyFilterDataQuery';
import { usePostInterestedFilterDataMutation } from '@/hooks/usePostInterestedFilterDataMutation';
import { GTM_EVENT_TYPE, trackGtmEvent } from '@/utils/analytics/gtm';
export const InterestedPolicyFilter = () => {
  const $ = _c(7);
  const router = useCustomRouter();
  const {
    data: filterValues,
    isLoading
  } = useGetInterestedPolicyFilterDataQuery();
  let t0;
  if ($[0] !== router) {
    t0 = {
      onSuccess: () => router.push(ROUTES.RECOMMEND_POLICY_LIST.pathname)
    };
    $[0] = router;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    mutate,
    isPending
  } = usePostInterestedFilterDataMutation(t0);
  let t1;
  if ($[2] !== filterValues || $[3] !== isLoading || $[4] !== isPending || $[5] !== mutate) {
    t1 = isLoading || !filterValues ? <LoadingPageTemplate /> : <Suspense fallback={<LoadingPageTemplate />}><InterestPolicyFilter initSelectedMetaData={filterValues} isSubmitting={isPending} submitButtonLabel={"\uC218\uC815 \uC644\uB8CC"} onSubmit={data => {
        const preferenceCategory = data.map(_temp).join(", ");
        trackGtmEvent(GTM_EVENT_TYPE.COMPLETE_PREFERENCE, {
          preference_category: preferenceCategory
        });
        mutate({
          codeList: data.map(_temp2)
        });
      }} /></Suspense>;
    $[2] = filterValues;
    $[3] = isLoading;
    $[4] = isPending;
    $[5] = mutate;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
};
function _temp(item) {
  return item.value;
}
function _temp2(t0) {
  const {
    code: t1,
    level: t2
  } = t0;
  const code = t1 === undefined ? "" : t1;
  const level = t2 === undefined ? 0 : t2;
  return {
    code,
    level
  };
}